import { getInitialPlanData } from "./getInitialPlanData";
import { AppDispatch } from "@store/store";
import { getPlan } from "@store/services/plan";

const initializeAnonymousUser = async (dispatch: AppDispatch) => {
  const planData = await getInitialPlanData();
  if (!planData.planId) {
    return;
  }

  dispatch(getPlan.initiate(Number(planData.planId)));
};

export { initializeAnonymousUser };
